module.exports = "43fc4da93a15d6176b09ad0c05f9dced.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-challenge-select.png
// module id = 106
// module chunks = 0